/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccountControllerDtoAccountDefaultInfoAccountPunishLightData from './AccountControllerDtoAccountDefaultInfoAccountPunishLightData';
import AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData from './AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData';
import AccountControllerDtoAccountDefaultInfoWithdrawalData from './AccountControllerDtoAccountDefaultInfoWithdrawalData';
import MaterialProperty from './MaterialProperty';

/**
 * The AccountControllerDtoAccountDefaultInfoResponse model module.
 * @module model/AccountControllerDtoAccountDefaultInfoResponse
 * @version 1.0
 */
class AccountControllerDtoAccountDefaultInfoResponse {
    /**
     * Constructs a new <code>AccountControllerDtoAccountDefaultInfoResponse</code>.
     * @alias module:model/AccountControllerDtoAccountDefaultInfoResponse
     */
    constructor() { 
        
        AccountControllerDtoAccountDefaultInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountDefaultInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountDefaultInfoResponse} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountDefaultInfoResponse} The populated <code>AccountControllerDtoAccountDefaultInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountDefaultInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nickname')) {
                obj['nickname'] = ApiClient.convertToType(data['nickname'], 'String');
            }
            if (data.hasOwnProperty('createAt')) {
                obj['createAt'] = ApiClient.convertToType(data['createAt'], 'Date');
            }
            if (data.hasOwnProperty('lastLoggedInAt')) {
                obj['lastLoggedInAt'] = ApiClient.convertToType(data['lastLoggedInAt'], 'Date');
            }
            if (data.hasOwnProperty('currentPower')) {
                obj['currentPower'] = ApiClient.convertToType(data['currentPower'], 'Number');
            }
            if (data.hasOwnProperty('maxPower')) {
                obj['maxPower'] = ApiClient.convertToType(data['maxPower'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('inactive')) {
                obj['inactive'] = ApiClient.convertToType(data['inactive'], 'Boolean');
            }
            if (data.hasOwnProperty('loginState')) {
                obj['loginState'] = ApiClient.convertToType(data['loginState'], 'Boolean');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('fiatBalance')) {
                obj['fiatBalance'] = ApiClient.convertToType(data['fiatBalance'], 'Number');
            }
            if (data.hasOwnProperty('freeBalance')) {
                obj['freeBalance'] = ApiClient.convertToType(data['freeBalance'], 'Number');
            }
            if (data.hasOwnProperty('availableWithdrawAmount')) {
                obj['availableWithdrawAmount'] = ApiClient.convertToType(data['availableWithdrawAmount'], 'Number');
            }
            if (data.hasOwnProperty('punishList')) {
                obj['punishList'] = ApiClient.convertToType(data['punishList'], [AccountControllerDtoAccountDefaultInfoAccountPunishLightData]);
            }
            if (data.hasOwnProperty('nicknameChangeHistory')) {
                obj['nicknameChangeHistory'] = ApiClient.convertToType(data['nicknameChangeHistory'], [AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData]);
            }
            if (data.hasOwnProperty('withdrawalInfo')) {
                obj['withdrawalInfo'] = AccountControllerDtoAccountDefaultInfoWithdrawalData.constructFromObject(data['withdrawalInfo']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountDefaultInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountDefaultInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['nickname'] && !(typeof data['nickname'] === 'string' || data['nickname'] instanceof String)) {
            throw new Error("Expected the field `nickname` to be a primitive type in the JSON string but got " + data['nickname']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }
        if (data['punishList']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['punishList'])) {
                throw new Error("Expected the field `punishList` to be an array in the JSON data but got " + data['punishList']);
            }
            // validate the optional field `punishList` (array)
            for (const item of data['punishList']) {
                AccountControllerDtoAccountDefaultInfoAccountPunishLightData.validateJSON(item);
            };
        }
        if (data['nicknameChangeHistory']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['nicknameChangeHistory'])) {
                throw new Error("Expected the field `nicknameChangeHistory` to be an array in the JSON data but got " + data['nicknameChangeHistory']);
            }
            // validate the optional field `nicknameChangeHistory` (array)
            for (const item of data['nicknameChangeHistory']) {
                AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData.validateJSON(item);
            };
        }
        // validate the optional field `withdrawalInfo`
        if (data['withdrawalInfo']) { // data not null
          AccountControllerDtoAccountDefaultInfoWithdrawalData.validateJSON(data['withdrawalInfo']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['email'] = undefined;

/**
 * @member {String} nickname
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['nickname'] = undefined;

/**
 * @member {Date} createAt
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['createAt'] = undefined;

/**
 * @member {Date} lastLoggedInAt
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['lastLoggedInAt'] = undefined;

/**
 * @member {Number} currentPower
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['currentPower'] = undefined;

/**
 * @member {Number} maxPower
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['maxPower'] = undefined;

/**
 * @member {Boolean} enabled
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['enabled'] = undefined;

/**
 * @member {Boolean} inactive
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['inactive'] = undefined;

/**
 * @member {Boolean} loginState
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['loginState'] = undefined;

/**
 * @member {String} invCode
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['invCode'] = undefined;

/**
 * @member {Number} fiatBalance
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['fiatBalance'] = undefined;

/**
 * @member {Number} freeBalance
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['freeBalance'] = undefined;

/**
 * @member {Number} availableWithdrawAmount
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['availableWithdrawAmount'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountDefaultInfoAccountPunishLightData>} punishList
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['punishList'] = undefined;

/**
 * @member {Array.<module:model/AccountControllerDtoAccountDefaultInfoNicknameChangeLogHistoryData>} nicknameChangeHistory
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['nicknameChangeHistory'] = undefined;

/**
 * @member {module:model/AccountControllerDtoAccountDefaultInfoWithdrawalData} withdrawalInfo
 */
AccountControllerDtoAccountDefaultInfoResponse.prototype['withdrawalInfo'] = undefined;






export default AccountControllerDtoAccountDefaultInfoResponse;

